import { render, staticRenderFns } from "./education.vue?vue&type=template&id=5af6e3e8&scoped=true&"
import script from "./education.vue?vue&type=script&lang=js&"
export * from "./education.vue?vue&type=script&lang=js&"
import style0 from "./education.vue?vue&type=style&index=0&id=5af6e3e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af6e3e8",
  null
  
)

export default component.exports